import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Loader2, Wand2 } from "lucide-react";
import { autoAssignSalons, fetchUnassigned } from "@/lib/bf";
import BFAssignPanel from "./BFAssignPanel";

export const UnassignedDot = () => {
  const [n, setN] = useState(0);
  useEffect(() => { fetchUnassigned().then((d) => setN(d.count)).catch(() => {}); }, []);
  return n > 0 ? <span className="bf-red-dot" title={`${n} saloane fără agent`} data-testid="bf-unassigned-dot">{n}</span> : null;
};

export default function BFUnassigned() {
  const [n, setN] = useState(0);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const load = () => fetchUnassigned().then((d) => setN(d.count)).catch(() => {});
  useEffect(() => {
    load();
    window.addEventListener("bf-unassigned-refresh", load);
    return () => window.removeEventListener("bf-unassigned-refresh", load);
  }, []);
  const auto = () => {
    setBusy(true);
    autoAssignSalons()
      .then((d) => { toast.success(d.moved.length ? `Am legat automat: ${d.moved.join(", ")}` : "Niciun salon nu a deschis linkul unui agent înainte. Mută-le manual."); load(); if (d.moved.length) setTimeout(() => window.location.reload(), 1200); })
      .catch(() => toast.error("Nu am putut lega saloanele"))
      .finally(() => setBusy(false));
  };
  return (
    <>
    {n > 0 && <section className="bf-unassigned" data-testid="bf-unassigned-alert">
      <AlertTriangle size={18} />
      <div>
        <b data-testid="bf-unassigned-count">{n} {n === 1 ? "salon înscris fără agent" : "saloane înscrise fără agent"}</b>
        <small>Le găsești marcate cu roșu în „Clienții tăi înscriși” de mai jos. Apasă „Mută” ca să le dai unui agent.</small>
      </div>
      <button type="button" className="st-btn st-btn--light" onClick={auto} disabled={busy} data-testid="bf-auto-assign-btn">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Wand2 size={14} />} Leagă automat după linkuri
      </button>
      <button type="button" className="st-btn st-btn--ghost" onClick={() => setOpen(true)} data-testid="bf-unassigned-go">Vezi lista</button>
    </section>}
    <BFAssignPanel open={open} onOpenChange={setOpen} />
    </>
  );
}
